<template lang="pug">
#navbar
  img(src='../assets/mini-noshi.png' alt='logo')
  router-link(to='/')
    i(class="fas fa-tshirt")
    span our shirts
  a(@click='showCartModal')
    i(class="fas fa-shopping-cart")
    span cart/checkout
  router-link(to='/contact')
    i(class="fas fa-comment-dots")
    span contact us

</template>

<script>
import { eventBus } from '../main'

export default {
methods: {
  showCartModal() {
    eventBus.$emit('showCartModal', true)
  },
}
}
</script>


<style lang="stylus" scoped>
#navbar
  height 90px
  background var(--dark)
  box-shadow 0 0.25em 0.5em var(--dark)
  display flex  // img and links take whole width
  align-items: center // verti and horiz
  font-family 'LondonTube', sans-serif
  font-size 1.2em

a
  display flex // for i's and spans contents
  flex-grow 1  // grows to fill navbar container
  font-size 2em
  height 100%
  align-items: center      // vertical
  justify-content center // i's spans horiz aligment
  cursor pointer
  &:hover
    background var(--med)

span
  margin-left .31rem


@media (max-width: 70em)
  a
    font-size 1.75em

@media (max-width: 58em)
  a
    font-size 1.5em

@media (max-width: 50em)
  #navbar
    flex-direction: column
    margin-bottom: 6em
    font-size 1em
  a
    background: var(--dark)
    width 100%



</style>